import Material1 from "@assets/KPMG/Material/material1.png";
import Material2 from "@assets/KPMG/Material/material2.png";
import Material3 from "@assets/KPMG/Material/material3.png";
import Material4 from "@assets/KPMG/Material/material4.png";
import Material5 from "@assets/KPMG/Material/material5.png";
import Material6 from "@assets/KPMG/Material/material6.png";
import Leadership1 from "@assets/KPMG/Leadership/1.png";
import Leadership2 from "@assets/KPMG/Leadership/2.png";
import Leadership3 from "@assets/KPMG/Leadership/3.png";
import Leadership4 from "@assets/KPMG/Leadership/4.png";
import Leadership5 from "@assets/KPMG/Leadership/5.png";
import Leadership6 from "@assets/KPMG/Leadership/6.png";
import Leadership7 from "@assets/KPMG/Leadership/7.png";
import Leadership8 from "@assets/KPMG/Leadership/8.png";
import Leadership9 from "@assets/KPMG/Leadership/9.png";
import Leadership10 from "@assets/KPMG/Leadership/10.png";

export const ThoughtLeadershipData: any = [
  {
    image: Leadership1,
    title: "Smarter Grids (kpmg.com)",
    href: "https://assets.kpmg.com/content/dam/kpmg/cn/pdf/en/2023/05/smarter-grids.pdf",
  },
  {
    image: Leadership2,
    title:
      "Repowering Europe: Transforming Europe into a more sustainable, self-sufficient energy economy (kpmg.com)​",
    href: "https://assets.kpmg.com/content/dam/kpmg/xx/pdf/2022/06/repowering-europe-report.pdf",
  },
  {
    image: Leadership3,
    title:
      "How small modular nuclear reactors can help decarbonize power grids (kpmg.com)​",
    href: "https://assets.kpmg.com/content/dam/kpmg/xx/pdf/2023/01/how-small-modular-nuclear-reactors-can-help-decarbonize.pdf",
  },
  {
    image: Leadership4,
    title: "Cities net zero (kpmg.com)​",
    href: "https://assets.kpmg.com/content/dam/kpmg/uk/pdf/2022/12/cities-net-zero.pdf",
  },
  {
    image: Leadership5,
    title: "Charging ahead (kpmg.com)​",
    href: "https://assets.kpmg.com/content/dam/kpmg/xx/pdf/2023/07/charging-ahead-addressing-the-ev-cost-hurdle.pdf",
  },
  {
    image: Leadership6,
    title: "Earth-Day-Campaign (kpmg.com)​",
    href: "https://spo-global.kpmg.com/sites/GO-OI-INF-ThoughtLeadership/SiteAssets/Forms/AllItems.aspx?id=%2Fsites%2FGO%2DOI%2DINF%2DThoughtLeadership%2FSiteAssets%2FSitePages%2FEarth%2DDay%2FEarth%2DDay%2DCampaign%5FLinkedIn%2DCarousel%5FFINAL%2Epdf&parent=%2Fsites%2FGO%2DOI%2DINF%2DThoughtLeadership%2FSiteAssets%2FSitePages%2FEarth%2DDay",
  },
  {
    image: Leadership7,
    title: "Aviation Leaders Report 2023 - New Horizons (kpmg.com)​",
    href: "https://assets.kpmg.com/content/dam/kpmg/ie/pdf/2023/01/ie-aviation-leaders-report-2023-new-horizons.pdf",
  },
  {
    image: Leadership8,
    title: "Emerging trends in infrastructure (kpmg.com)​",
    href: "https://spo-global.kpmg.com/sites/GO-OI-INF-ThoughtLeadership/Lists/GlobalTLContentSubmission/Attachments/118/GM-TL-01470_Emerging%20Trends%20TL_V4_Web.pdf",
  },
  {
    image: Leadership9,
    title: "Building project manufacturers get smart (kpmg.us)​",
    href: "https://advisory.kpmg.us/content/dam/advisory/en/pdfs/2023/building-product-manufacturers-smart.pdf",
  },
  {
    image: Leadership10,
    title:
      "How can ESG fintech help financial institutions and their clients drive a net-zero future? (kpmg.com)​​",
    href: "https://assets.kpmg.com/content/dam/kpmg/sg/pdf/2023/06/KPMG-2023-post-event-report-how-can-esg-fintech-help-financial-institutions-and-their-clients-drive-a-net-zero-future.pdf",
  },
];
export const mockData: any = [
  {
    list: [
      {
        image: Material1,
        title: "06 Feb 2023",
        description:
          "A pilot of coated pavement surfaces to address the heat island effect in the UAE",
      },
      {
        image: Material2,
        title: "06 Feb 2023",
        description:
          "A pilot of coated pavement surfaces to address the heat island effect in the UAE",
      },
      {
        image: Material3,
        title: "06 Feb 2023",
        description:
          "A pilot of coated pavement surfaces to address the heat island effect in the UAE",
      },
    ],
  },
  {
    list: [
      {
        image: Material3,
        title: "06 Feb 2023",
        description:
          "A pilot of coated pavement surfaces to address the heat island effect in the UAE",
      },
      {
        image: Material1,
        title: "06 Feb 2023",
        description:
          "A pilot of coated pavement surfaces to address the heat island effect in the UAE",
      },
      {
        image: Material2,
        title: "06 Feb 2023",
        description:
          "A pilot of coated pavement surfaces to address the heat island effect in the UAE",
      },
    ],
  },
  {
    list: [
      {
        image: Material2,
        title: "06 Feb 2023",
        description:
          "A pilot of coated pavement surfaces to address the heat island effect in the UAE",
      },
      {
        image: Material3,
        title: "06 Feb 2023",
        description:
          "A pilot of coated pavement surfaces to address the heat island effect in the UAE",
      },
      {
        image: Material1,
        title: "06 Feb 2023",
        description:
          "A pilot of coated pavement surfaces to address the heat island effect in the UAE",
      },
    ],
  },
];
